/*!
 * liveAnalysers.js — each sounding voice's analyser, by its uid
 * © 2026 Rob Canning — GPLv3
 *
 * So a box can draw another sound than its own: viz(s1, view:xy, y:s2)
 * plots s1 across against s2 up (scopeViews.js xyPoints). synth() registers
 * a voice's analyser as it starts and drops it as it stops; a voice needs
 * no box of its own to be found (waveform:none is fine). A poly voice's
 * sub-voices (s2__3) are found by the uid they share, the newest first.
 */

const byUid = new Map();

// The external input (adc.js) is asked for before it draws: the browser's
// prompt can take a while to answer. viz(adc, ...) waits for its box while
// the name is here, not only its usual few seconds.
const pending = new Set();
export const markPending = (uid, on) => (on ? pending.add(String(uid)) : pending.delete(String(uid)));
export const isPending = uid => pending.has(String(uid));

export function registerAnalyser(uid, analyser) {
  if (uid && analyser) byUid.set(String(uid), analyser);
}

/** Drop uid's analyser -- only if it is still that one (a newer voice may have replaced it). */
export function unregisterAnalyser(uid, analyser = null) {
  const k = String(uid);
  if (!analyser || byUid.get(k) === analyser) byUid.delete(k);
}

export function analyserFor(uid) {
  const k = String(uid ?? "");
  if (!k) return null;
  if (byUid.has(k)) return byUid.get(k);
  let found = null;
  for (const [u, a] of byUid) if (u.startsWith(`${k}__`)) found = a;   // the newest sub-voice
  return found;
}
